import { WorldThumbnail } from "./WorldThumbnail";
import styles from "./GoalThumbnail.module.css";

interface GoalThumbnailProps {
  goal: string;
}

/**
 * Shows the goal world for a checked lesson. The "View World / View Goal"
 * button in the panel header toggles the whole overlay, so the live IDE world
 * (the start state) is what the student sees when the goal panel is hidden.
 */
export function GoalThumbnail({ goal }: GoalThumbnailProps) {
  return (
    <div className={styles.wrapper}>
      <WorldThumbnail world={goal} />
    </div>
  );
}
